import {
  Button,
  Colors,
  Cross,
  Modal,
  NavigationNotification,
  Typography,
  TypographyWithIcon
} from '@giantleap/components-library'
// import CrownIcon from 'assets/img/crown.svg'
// import ReactSVG from 'react-svg'
import * as React from 'react'
import { _route } from '../../routes/config'
import styles from './style.module.scss'
interface IProps {
  setActive: (status: boolean) => void
  history: any
  open: boolean
}

export const PlusOnlyPopup: React.FC<IProps> = ({
  setActive,
  history,
  open
}: IProps) => {
  return (
    <Modal
      active={open}
      setActive={setActive}
      baseClassName={styles.wrap}
      x={<Cross size="big" color={Colors.unselected} />}
    >
      <TypographyWithIcon justifyContent="center">
        <Typography type="title">Plus Only</Typography>
        <NavigationNotification icon="crown" />
      </TypographyWithIcon>

      <Typography type="text">
        Get GiantLeap Plus to unlock this feature and more!
      </Typography>
      <Button
        color="pink"
        onClick={() => history.push(_route.payment, { canGoBack: true })}
        type="max"
      >
        Remove limit
      </Button>
    </Modal>
  )
}

export default PlusOnlyPopup



// WEBPACK FOOTER //
// ./src/components/PlusOnlyPopup/index.tsx